import { isSystem } from '@umu/ukit-lang';
import { addQueryString } from '@umu/umu-dom';
import { isMobile, isUMUWebview, isIos, getAppNumVersion } from '@umu/umu-ua';

const appVersion = getAppNumVersion();
export const supportAppDownload = isUMUWebview && (isIos || (isSystem('CO') ? appVersion >= 70517 : appVersion >= 70519));

/**
 * 文件尺寸转换
 * @param fileSize
 */
export function getFileSize(fileSize: number): string {
    const size = Number(fileSize) || 0;
    let sizeString = fileSize + '';
    if (size < 1024) {
        sizeString = size + 'B';
    } else if (size < 1048576) {
        sizeString = parseFloat((size / 1024).toFixed(1)) + 'KB';
    } else if (fileSize < 1073741824) {
        sizeString = parseFloat((size / 1048576).toFixed(1)) + 'MB';
    } else {
        sizeString = parseFloat((size / 1073741824).toFixed(1)) + 'GB';
    }
    return sizeString;
}

export const downloadByLink = (uri: string, name: string = 'doc') => {
    const link = document.createElement('a');
    link.download = name;
    link.href = uri;
    link.click();
};

export const downloadByIFrame = (url: string) => {
    const hiddenIFrameID = 'hiddenDownloader';
    let iframe = document.getElementById(hiddenIFrameID) as HTMLIFrameElement;
    if (iframe === null) {
        iframe = document.createElement('iframe');
        iframe.id = hiddenIFrameID;
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
    }
    iframe.src = url;
};

export const downloadFileByBlob = (
    url: string,
    fileName: string,
    option: { onSuccess?: VoidFunction; onFail?: VoidFunction } = {},
) => {
    const { onSuccess, onFail } = option;

    if (navigator.onLine === false) {
        onFail?.();
        return;
    }

    const a: HTMLAnchorElement = document.createElement('a');
    const appendAndClick = (element: HTMLAnchorElement, url: string) => {
        element.href = url;
        element.download = fileName;
        (document.body || document.documentElement).appendChild(element);
        element.click();
        onSuccess?.();
        setTimeout(() => {
            element.parentNode!.removeChild(element);
        }, 300);
    };

    const notSupportBlobDownload = !('download' in a) && !('msSaveOrOpenBlob' in navigator);
    // webview 以及一些移动端浏览器不支持 blob 下载, 直接走 a 标签下载
    if (isMobile || notSupportBlobDownload) {
        appendAndClick(a, url);
        return;
    }

    const xhr = new XMLHttpRequest();
    xhr.open('GET', addQueryString(url, { t: Date.now() }), true);
    xhr.responseType = 'blob';

    xhr.onload = () => {
        if (xhr.status === 200) {
            if ('msSaveOrOpenBlob' in navigator) {
                // @ts-ignore
                navigator.msSaveOrOpenBlob(xhr.response, fileName);
                onSuccess?.();
                return;
            }

            const objectURL = URL.createObjectURL(xhr.response);
            appendAndClick(a, objectURL);
            URL.revokeObjectURL(objectURL);
            return;
        }
        onFail?.();
    };

    xhr.onerror = () => {
        onFail?.();
    };

    xhr.onabort = () => {
        onFail?.();
    };

    xhr.send();
};
